import {DEFAULT_LOCALE} from '../../constants';
import {BASE_PATH} from '../../constants/routes';

/**
 * Reads one locale from the server, which holds the edition downloaded from the localization
 * service. The messages are no longer bundled, so switching locale is a request, not a chunk.
 *
 * @param locale - the locale to read
 * @returns the messages of that locale
 */
export default async function getTranslations(locale = DEFAULT_LOCALE) {
    const response = await fetch(`${BASE_PATH}/i18n/${locale}`);

    if (!response.ok) {
        throw new Error(`Could not load translations for '${locale}': responded ${response.status}`);
    }

    return response.json();
}
